import React, { useState, forwardRef  } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faThumbsUp, faUser, faStar, faEnvelope, faHeart, faEye  } from '@fortawesome/free-solid-svg-icons';
import { Dropdown } from 'react-bootstrap';
import { useNotifications } from '../../context/NotificationContext';
import { useUserContext } from '../../context/UserContext';
import { Link } from 'react-router-dom';

const NotificationBell = ({ type = 'likes', label = 'Likes' }) => {
  const { getUnreadCount, getNotifications, clearNotifications } = useNotifications();
  const { users } = useUserContext(); // Get user list
  const [showDropdown, setShowDropdown] = useState(false);

  const unreadCount = getUnreadCount(type);
  const notifications = getNotifications(type);

  const toggleDropdown = (isOpen) => {
    setShowDropdown(isOpen);
    if (!isOpen && unreadCount > 0) {
      clearNotifications(type);
    }
  };

  // Icon mapping by type
  const iconsArr = {
    "likes": faHeart,
    "messages": faEnvelope,
    "views": faEye
  }

  // Get senderId field based on notification type
  const getSenderId = (item) => {
    if (type === 'likes') return item.likerId;
    if (type === 'messages') return item.senderId;
    if (type === 'views') return item.viewerId;
    return null;
  };

  // Generate human-readable message
  const getNotificationMessage = (user) => {
    console.log("NotificationBell getNotificationMessage", user)
    if (!user) return 'Unknown user';
    switch (type) {
      case 'likes':
        return `${user.username} liked you`;
      case 'messages':
        return `${user.username} sent you a message`;
      case 'views':
        return `${user.username} viewed your profile`;
      default:
        return `${user.username} sent you a notification`;
    }
  };

  // Custom icon toggle (bell with badge)
  const CustomToggle = forwardRef(({ onClick }, ref) => (
    <div
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
      style={{ cursor: 'pointer', position: 'relative', color: 'white' }}
    >
      <FontAwesomeIcon icon={iconsArr[type]} size="lg" />
      {unreadCount > 0 && (
        <div style={{
          position: 'absolute',
          top: -5,
          right: -10,
          backgroundColor: 'red',
          color: 'white',
          borderRadius: '50%',
          width: 18,
          height: 18,
          fontSize: 12,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}>
          {unreadCount}
        </div>
      )}
    </div>
  ));

  return (
    <div style={{ position: 'relative', marginRight: 20 }}>
      <Dropdown show={showDropdown} onToggle={toggleDropdown} align="end">
        <Dropdown.Toggle as={CustomToggle} />
        <Dropdown.Menu style={{ minWidth: 250 }}>
          <Dropdown.Header>{label} Notifications</Dropdown.Header>
          {notifications.length === 0 ? (
            <Dropdown.ItemText>No new {label.toLowerCase()}</Dropdown.ItemText>
          ) : (
            notifications.map((item, index) => {
              console.log("NotofocationBell item", item);
              const senderId = getSenderId(item);
              console.log("NotofocationBell senderId", senderId);
              const user = users.find(u => u.userId === item.likedId);
              if (!user) {
                console.warn("User not found for ID:", senderId, "Available users:", users);
              }
              return (
                <Dropdown.Item
                  as={Link}
                  to={`/profile/${item.likerId}`} // Link to profile
                  key={index}
                  style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
                >
                  <img
                    src={
                      user?.profilePicture ||
                      (user?.ownGenderId === 1 ? '/avatars/female.png' : '/avatars/male.png')
                    }
                    alt="avatar"
                    style={{ width: 32, height: 32, borderRadius: '50%', objectFit: 'cover' }}
                  />
                  <span>
                    <span>{getNotificationMessage(user)}</span>
                  </span>
                </Dropdown.Item>
              )
            })
          )}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};

export default NotificationBell;
